import {_Orders as Orders} from "./_Orders";

export const ModuloFoodAPI = {
    Orders: Orders
};